import App from 'app/app.js';

function LtAddonCarouselController($scope, $window, $timeout, $element) {
  this.chunkedAddons = [];
  this.pageIndex = 0;

  this.ignoreScrollEvents = false;
  this.isAnimating = false;
  this.pendingAction = null;

  this.getScrollArea = () => {
    const area = $element[0].querySelector('.carousel-body');
    return area || null;
  };

  this.init = () => {
    this.chunkedAddons = [];
    const addons = ($scope.addons || []).slice();
    const colSize = $window.innerWidth >= 768 ? 8 : 4;

    while (addons.length > 0) {
      this.chunkedAddons.push(addons.splice(0, colSize));
    }

    this.attachScrollHandler();
    this.pageIndex = 0;

    $timeout(() => this.updateScroll(), 50);
  };

  this.attachScrollHandler = () => {
    const scrollArea = this.getScrollArea();
    if (!scrollArea) return;

    let scrollTimeout = null;

    scrollArea.addEventListener('scroll', () => {
      if (this.ignoreScrollEvents) return;

      if (scrollTimeout) $timeout.cancel(scrollTimeout);

      scrollTimeout = $timeout(() => {
        const width = scrollArea.getBoundingClientRect().width;
        const index = Math.round(scrollArea.scrollLeft / width);

        $scope.$applyAsync(() => {
          this.pageIndex = index;
        });
      }, 80);
    });
  };

  this.queueOrRun = (action) => {
    if (this.isAnimating) {
      this.pendingAction = action;
      return true;
    }
    return false;
  };

  this.prevPage = () => {
    if (this.queueOrRun({ type: 'prev' })) return;

    if (this.pageIndex > 0) {
      this.pageIndex--;
      this.updateScroll();
    }
  };

  this.nextPage = () => {
    if (this.queueOrRun({ type: 'next' })) return;

    if (this.pageIndex < this.chunkedAddons.length - 1) {
      this.pageIndex++;
      this.updateScroll();
    }
  };

  this.indicatorScroll = (index) => {
    if (this.queueOrRun({ type: 'indicator', index })) return;

    this.pageIndex = index;
    this.updateScroll();
  };

  this.forceResetScroll = () => {
    this.pageIndex = 0;
    const scrollArea = this.getScrollArea();
    if (!scrollArea) return;

    this.isAnimating = false;
    this.ignoreScrollEvents = true;
    this.pendingAction = null;

    scrollArea.scrollTo({
      left: 0,
      behavior: 'auto'
    });

    $timeout(() => {
      this.ignoreScrollEvents = false;
    }, 30);
  };

  this.updateScroll = () => {
    const scrollArea = this.getScrollArea();
    if (!scrollArea) return;

    const width = scrollArea.getBoundingClientRect().width;
    const targetLeft = Math.round(this.pageIndex * width);

    this.isAnimating = true;
    this.ignoreScrollEvents = true;

    scrollArea.scrollTo({ left: targetLeft, behavior: 'smooth' });

    let stableCount = 0;
    let lastLeft = -9999;

    const checkDone = () => {
      const currentLeft = scrollArea.scrollLeft;

      stableCount = Math.abs(currentLeft - lastLeft) < 1 ? stableCount + 1 : 0;
      lastLeft = currentLeft;

      if (stableCount >= 2) {
        this.isAnimating = false;
        this.ignoreScrollEvents = false;

        if (this.pendingAction) {
          const action = this.pendingAction;
          this.pendingAction = null;

          if (action.type === 'next') this.nextPage();
          else if (action.type === 'prev') this.prevPage();
          else if (action.type === 'indicator') this.indicatorScroll(action.index);
        }
        return;
      }

      $timeout(checkDone, 30);
    };

    $timeout(checkDone, 30);
  };

  this.selectItem = (item) => {
    $scope.confirm({ selectedItem: item });
    this.forceResetScroll();
  };

  $scope.$on('CYOP_CAROUSEL_RESET', () => {
    this.forceResetScroll();
  });
}

App.controller('LtAddonCarouselCtrl', ['$scope', '$window', '$timeout', '$element', LtAddonCarouselController]);
